import React, { useState, useEffect } from 'react';
import TouchableItem from './TouchableItem';
import styled, { css } from 'styled-components';
import { MaxWidth } from '../../base';

type Position = 'right' | 'center';
type Props = {
  position: Position;
  arrow?: boolean;
  isOpen?: boolean;
};

const PopoverContent = styled.div<Props>`
  display: block;
  position: absolute;
  min-width: 320px;
  max-width: 320px;
  padding: 20px;
  margin-top: 16px;
  z-index: 100;
  border-radius: 4px;
  background-color: ${({ theme: { colors } }) => colors.light.primary};
  border: 1px solid ${({ theme: { colors } }) => colors.gray.stain};
  ${props =>
    props.position === 'right'
      ? css`
          right: 0;
        `
      : css`
          left: 0;
        `};
  ${props =>
    props.position === 'center' &&
    css`
      left: 50%;
      transform: translateX(-50%);
    `};

  ${MaxWidth.sm`
    min-width: 200px;
    max-width: 200px;
  `}
`;

const Arrow = styled.span<any>`
  border: solid ${({ theme: { colors } }) => colors.dark.light};
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;
  width: 12px;
  height: 12px;
  vertical-align: middle;
  margin-left: 8px;
  margin-top: -8px;
  transition: all ease-in-out 0.4s;
  transform: rotate(45deg);
  ${props =>
    props.isOpen
      ? css`
          transform: rotate(-135deg);
          margin-top: 2px;
        `
      : null}
`;

export default function Popover({ children, arrow = false, position = 'right', popoverContent }) {
  const containerRef = React.createRef<HTMLDivElement>();
  const [isOpen, setIsOpen] = useState();
  function handleClickOutside({ target }) {
    if (containerRef && containerRef.current && !containerRef.current.contains(target)) {
      setIsOpen(false);
    }
  }
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });
  return (
    <TouchableItem onClick={() => setIsOpen(!isOpen)} ref={containerRef}>
      {children}
      {arrow && <Arrow isOpen={isOpen} />}
      {isOpen && <PopoverContent position={position as Position}>{popoverContent}</PopoverContent>}
    </TouchableItem>
  );
}
